var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-result',{staticClass:"error-result",attrs:{"icon":"error","title":"404","subTitle":"找不到当前页面"}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.goHome}},[_vm._v("返回主页")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }